import type { ReportsRepository, ReportSummary, ReportDetail } from "./ReportsRepository";
import axios from "axios";

type ApiGeneratedReport = {
  id: string;
  title: string;
  createdAt: string;
  projectName?: string | null;
  inspectionName?: string | null;
  totalImages: number;
  totalDetections: number;
};

export class ApiReportsRepository implements ReportsRepository {
  async listReports(): Promise<ReportSummary[]> {
    const res = await axios.get<ApiGeneratedReport[]>("/api/reports");
    return res.data.map((report) => ({
      id: report.id,
      title: report.title,
      date: report.createdAt,
      status: "ready",
      totalImages: report.totalImages,
      totalDetections: report.totalDetections,
      projectName: report.projectName,
      inspectionName: report.inspectionName,
    }));
  }

  async getReport(id: string): Promise<ReportDetail> {
    const report = (await this.listReports()).find((item) => item.id === id);
    if (!report) {
      throw new Error("Report not found");
    }

    return {
      ...report,
      clientName: "",
      inspectionName: report.inspectionName ?? "",
    };
  }

  async downloadReportPdf(id: string): Promise<Blob> {
    const res = await axios.get(`/api/reports/${id}/pdf`, {
      responseType: "blob",
    });

    return new Blob([res.data], { type: "application/pdf" });
  }
}
